import { EProductWithVariants } from '@gelato-api-ui/core/e-commerce/e-product-with-variants';
import { pluckValueFromProductVariants } from '@gelato-api-ui/core/e-commerce/helpers/pluckValueFromProductVariants';

export const getSanityCategoryIdFromEProduct = (product: EProductWithVariants): string =>
  pluckValueFromProductVariants(product, 'sanityCategoryId');
